<template>
  <div class="pa-2">
    <v-row dense>
      <!-- نام مجموعه / فروشگاه -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="labelData.name.text"
          append-icon="mdi-domain"
          dense
          outlined
          counter="50"
          label="نام مجموعه / فروشگاه"
          hint="نام فروشگاه یا کمپانی خود را وارد کنید"
          persistent-hint
        />
      </v-col>

      <!-- برند محصول -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="labelData.brand.text"
          append-icon="mdi-tag-outline"
          dense
          outlined
          counter="50"
          label="برند کالا"
          hint="برند یا شرکت سازنده محصول (مثلاً سامسونگ، کاله و ...)"
          persistent-hint
        />
      </v-col>

      <!-- نام محصول -->
      <v-col cols="12" md="12">
        <v-text-field
          v-model="labelData.labelName.text"
          append-icon="mdi-basket"
          dense
          outlined
          counter="50"
          label="نام محصول"
          hint="عنوان اصلی لیبل محصول"
          persistent-hint
        />
      </v-col>

      <!-- قیمت تولید -->
      <v-col cols="12" md="6" class="d-flex align-center">
        <price-input
          v-model="labelData.price.text"
          label="قیمت تولید"
          dense
          outlined
        />
      </v-col>

      <!-- قیمت مصرف‌کننده -->
      <v-col cols="12" md="6" class="d-flex align-center">
        <price-input
          v-model="labelData.bPrice.text"
          label="قیمت مصرف کننده"
          dense
          outlined
        />
      </v-col>

      <!-- قیمت خرید مشتری -->
      <v-col cols="12" md="6" class="d-flex align-center">
        <price-input
          v-model="labelData.cPrice.text"
          label="قیمت خرید مشتری"
          dense
          outlined
        />
      </v-col>

      <!-- درصد تخفیف -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="labelData.discount.text"
          label="درصد تخفیف"
          type="number"
          outlined
          dense
          append-icon="mdi-sale"
        />
      </v-col>

      <!-- توضیحات محصول -->
      <v-col cols="12">
        <v-textarea
          v-model="labelData.discriptions.text"
          label="توضیحات تکمیلی محصول"
          outlined
          dense
          rows="3"
          counter="2000"
        />
      </v-col>

      <!-- دکمه تصمیم‌گیری برای مشاهده بیشتر در توضیحات -->
      <v-col cols="12" class="pt-0">
        <v-switch
          v-model="labelData.discriptions.collapse"
          color="primary"
          dense
          inset
          label="نمایش خلاصه ۳ خطی با دکمه «مشاهده بیشتر» در پیش‌نمایش"
          hint="در صورت فعال بودن، توضیحات بلند پس از ۳ خط خلاصه شده و با کلیک کاربر کامل باز می‌شود."
          persistent-hint
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PriceInput from "../../uiBeautifier/priceInput.vue";

export default {
  name: "PriceLabelInfo",
  components: {
    PriceInput,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    labelData() {
      const data = this.value.label || this.value;
      if (!data.brand) {
        this.$set(data, "brand", { text: "", line: false });
      }
      if (data.discriptions && typeof data.discriptions.collapse === "undefined") {
        this.$set(data.discriptions, "collapse", true);
      }
      return data;
    },
  },
};
</script>
